export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
        resource: 'Dashboard',
        action: 'read',
      },
    ],
  },
]
